import {
  bg,
  de,
  enUS,
  es,
  fr,
  hu,
  it,
  ja,
  pt,
  ro,
  sk,
  sr,
  type Locale,
} from "date-fns/locale";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller } from "react-hook-form";
import { type Translationtype } from "utils";
import { Tooltip } from "../components/tooltip";

interface IFormDateInputProps {
  errors: any;
  control: any;
  name: string;
  className?: string;
  title: string;
  minDate?: any;
  maxDate?: any;
  selectedDate?: any;
  t: Translationtype;
  setDate?: any;
  tooltip?: any;
  intervalEnd?: boolean;
  i18n: string;
  isRequired?: boolean;
  disabled?: boolean;
}

const localeMap: Record<string, Locale> = {
  hu,
  de,
  en: enUS,
  ja,
  fr,
  sk,
  it,
  pt,
  ro,
  es,
  bg,
  sr,
};

export function FormDateTimeInput({
  tooltip,
  control,
  name,
  title,
  minDate,
  maxDate,
  className,
  errors,
  intervalEnd,
  i18n,
  isRequired = false,
  disabled,
}: IFormDateInputProps) {
  const currentLang = i18n.split("-")[0];
  const dateFnsLocale = localeMap[currentLang] || enUS;
  return (
    <div className={`${className || ""} w-full`}>
      <label htmlFor={name} className="block mb-1 text-textColor">
        {title}
        {isRequired ? <span className="text-red-500"> *</span> : null}{" "}
        {tooltip ? <Tooltip text={tooltip} /> : null}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <DatePicker
              disabled={disabled}
              name={name}
              locale={dateFnsLocale}
              wrapperClassName="w-full"
              showTimeSelect
              selected={field.value ? new Date(field.value) : field.value}
              onChange={(date) => {
                if (intervalEnd) {
                  const selectedDateTime = dayjs(date);
                  const isMidnight = selectedDateTime.isSame(
                    selectedDateTime.startOf("day")
                  );
                  if (isMidnight) {
                    field.onChange(dayjs(date).endOf("day").toDate());
                  } else {
                    field.onChange(date);
                  }
                } else {
                  field.onChange(date);
                }
              }}
              isClearable
              minDate={minDate}
              maxDate={maxDate}
              timeFormat="HH:mm"
              timeIntervals={1}
              dateFormat="Pp"
              calendarStartDay={1}
              autoComplete="off"
              className="block h-[48px] w-full px-4 py-2 border rounded-md shadow-sm input"
            />
            {errors[`${name}`]?.message !== undefined && (
              <p className="text-sm my-3 text-error">
                {`${errors[`${name}`]?.message}`}
              </p>
            )}
          </>
        )}
      />
    </div>
  );
}
